import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./components/cube/authContext/index.js";
import NoAccessPage from "./components/cube/NoAccessPage.jsx";

import SexualHealthEducation from "./components/cube/sexualhealth/SexualHealthEducation.jsx";
import MentalHealthHub from "./components/cube/mental/thereapy/ThearpyTools.jsx";
import StandaloneAssessment from "./components/cube/assessments/StandaloneAssessment.jsx";
import AIPage from "./components/cube/aipage.jsx";
import WelcomePage from "./components/cube/WelcomePage.jsx";

const PageAccessLogger = () => {
  const location = useLocation();
  const { logPageAccess } = useAuth();

  useEffect(() => {
    logPageAccess(location.pathname);
  }, [location.pathname, logPageAccess]);

  return null; 
};

const AppContent = () => {
  const { loading, isValidSession } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Validating wellness session...</p>
        </div>
      </div>
    );
  }

  if (!isValidSession) {
    return <NoAccessPage />;
  }

  return (
    <>
      <PageAccessLogger />
      <Routes>
        <Route path="/therapy-tool" element={<MentalHealthHub />} />
        <Route path="/self-assessment" element={<StandaloneAssessment />} />
        <Route path="/sexual-health" element={<SexualHealthEducation />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/" element={<AIPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;